/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable camelcase */
import React, { useState, useRef, useEffect, useContext, use } from 'react'
import './notifications.css'
import Popups from '../popup/popupwithposition'
import ActionButton from '../buttons/actionbutton'
import Tabs from '../tabs/tabs'
import { PopupCloseContext, UserInitalValue } from '../../store/contexts/popupclose-context'
import Notificationtabcontent from './notification-items'
import Buttons from '../buttons/buttons'
import { getNotificationItems } from '../../modules/TRM/services/trmNotificationList'
import { UserContext } from '../../store/contexts/UserContextProvider'
import { TRMNotification } from '../../types/listDataTypes'
import { clear } from 'console'
import { BulkModeTransaction, BulkUpdate, IBulkListDataRequest } from '@rhybus/api'
import { ListNames } from '../../shared/constants/globalConstants'
import { anewRListsHttp } from '../../shared/services/api/anew-r-lists-http'
import PageOverlay from '../pageoverlay/PageOverLay'
interface Props{
    toogleNotification: boolean
}
export default function Notifications(props:Props) {
  const [activeTab, setActiveTab] = useState<number>(0)
  const [visibleRows, setVisibleRows] = useState(30)
  const [notificationData, setNotificationData] = useState<TRMNotification[]>([])
  const [unReadCount, setunReadCount] = useState<string>('0')
  const [actionNotificationsData, setActionNotificationsData] = useState<TRMNotification[]>([])
  const [notifyNotificationsData, setnotifyNotificationsData] = useState<TRMNotification[]>([])
  const [filteredNotifications, setFilteredNotifications] = useState<TRMNotification[]>([])
  const [isAlertsFullscreen,setisAlertsFullscreen]=useState<boolean>(false)
  const [isApppageoverlay,setIsApppageoverlay]=useState<boolean>(false)
  const [isPageOverlay, setIsPageOverlay] = useState<boolean>(false)
  const buttonRef = useRef<HTMLButtonElement>(null)
  const { me,isUserDetailsLoading,userRoles } = use(UserContext)

  useEffect(() => {
    const sortedNotifications = [...notificationData]?.filter(item => item?.IsRead === false)?.sort((a: any, b: any) => new Date(b?.ItemCreated as string)?.getTime() - new Date(a?.ItemCreated as string)?.getTime());
    setFilteredNotifications(sortedNotifications)
    setActionNotificationsData(sortedNotifications?.filter((item: any) => item?.NotificationType === 'ACTION'))
    setnotifyNotificationsData(sortedNotifications?.filter((item: any) => item?.NotificationType === 'NOTIFICATION'))
    setunReadCount(notificationData?.filter((notification:TRMNotification ) => !notification?.IsRead)?.length?.toString()?.padStart(2, '0'))
  }, [notificationData])

  const notification_items = [
    {
      tabtitle: `All (${String(filteredNotifications?.length).padStart(2,'0')})`,
      is_active: activeTab === 0,
      content: (<><Notificationtabcontent  notificationItems={filteredNotifications} getNotications={getNotications} tabId={'all'} setNotificationData={setNotificationData}/></>)
    },
    {
      tabtitle: `Actions (${String(actionNotificationsData?.length).padStart(2,'0')})`,
      is_active: activeTab === 1,
      content: (<><Notificationtabcontent notificationItems={actionNotificationsData} getNotications={getNotications} tabId={'actions'} setNotificationData={setNotificationData}/></>)
    },
    {
      tabtitle: `Notifications (${String(notifyNotificationsData?.length).padStart(2,'0')})`,
      is_active: activeTab === 2,
      content: (<><Notificationtabcontent notificationItems={notifyNotificationsData} getNotications={getNotications} tabId={'notifications'} setNotificationData={setNotificationData}/></>)
    }
  ]
  useEffect(()=> {
    if(!isUserDetailsLoading)
    getNotications()
  },[isUserDetailsLoading,props?.toogleNotification])
  async function getNotications(){
      const items = await getNotificationItems(me?.userId) as TRMNotification[]
      setNotificationData(items)
  }

  // Context for handling multiple popups
  const { multiplePopup, setMultiplePopup }: typeof UserInitalValue = useContext(PopupCloseContext)
  const notificationPopup = useRef<HTMLButtonElement>(null)
  const PopupWindow = (ele: string) => {
    setisAlertsFullscreen(false)
   // setMultiplePopup((prevPopup: string | null) => (prevPopup === ele ? null : ele))
     setMultiplePopup((prevPopup: any) => {
            if (prevPopup === ele) {
                setIsApppageoverlay(false)
                return null
            }
            setIsApppageoverlay(true)
            return ele
        })
    setActiveTab(0)
  }
  const showAlertsFull=()=>{
      setisAlertsFullscreen(!isAlertsFullscreen)
  }
  const clearAllNotifications = async () => {
    const bulkItems: IBulkListDataRequest[] = []; 
    const updateNotifications = activeTab === 0 ? filteredNotifications?.map((notification:TRMNotification ) => { return {...notification, IsRead: true} }) : 
    activeTab === 1 ? actionNotificationsData?.map((notification:TRMNotification ) => { return {...notification, IsRead: true} }) :
    notifyNotificationsData?.map((notification:TRMNotification ) => { return {...notification, IsRead: true} })
    bulkItems.push({
      ListName: ListNames.TRMNotificationsList,
      BulkOperation: BulkUpdate,
      ListData: [
        ...updateNotifications
      ],
      IsResponseNeeded: false
    } as IBulkListDataRequest);
    setIsPageOverlay(true)
    try{
      const bulk = anewRListsHttp().processBulkByListData(BulkModeTransaction, bulkItems)
      await bulk.execute()
      await getNotications()
      setIsPageOverlay(false) 
    } catch (error) {
      setIsPageOverlay(false)
    }
  }
  return (
    <div className="notification">
      {isApppageoverlay && <div className='app-page-overlay'></div>}
      {isPageOverlay && <PageOverlay />}
      <ActionButton
        label="Notifications"
        name=''
        className={multiplePopup === 'notification' ? 'btn btn-sm p-0 p-relative notify-btn' : 'btn btn-sm p-0 p-relative notify-btn'}
        icon="icon-notification font-20 font-lg-16 text-color-66"
        type="button"
        aria-expanded={multiplePopup === 'notification' ? 'true' : 'false'}
        badgeinfo={unReadCount !== '00' ? unReadCount : '0'}
        badge="badge bgcolor-primary btn-border-radius-3 px-1 font-10 whitetext"
        ref={notificationPopup}
        onClick={() => PopupWindow('notification-popup')}
      />
      {multiplePopup === 'notification-popup' && (
        <Popups buttonRef={notificationPopup} popupId="notification-popup" className={`dropdown-popup whitebg border-1 fade-in notification-popup ${isAlertsFullscreen ? 'alert-fullscreen':'alert-popup-collapse'}`} popupContent={
          <>
            
            <div className="d-flex w-100 p-relative align-items-center border-bottom-1 notification-header">
              <Buttons label="back"
                icon="icon-rb-arrow-left-thick font-16"
                className="btn btn-lg font-0 px-0 d-flex d-none-lg"
                onClick={()=>{setisAlertsFullscreen(false)}}
              />
              <h2 tabIndex={0} aria-label="Alerts" className="d-flex align-items-center font-16 alert-title sora-semibold ">
                <span className="icon-notification font-16 pe-1"></span> Alerts
              </h2>
              <div className='ms-auto d-flex align-items-center gap-2'>
                 {(activeTab === 0 ? filteredNotifications?.length > 0 : activeTab === 1 ? actionNotificationsData?.length > 0 : notifyNotificationsData?.length > 0) && <Buttons
                   label="Mark All as Read"
                   className='p-0 btn btn-md text-color-11 font-11 sora-semibold lh-normal'
                   type="button"
                   onClick={clearAllNotifications}
                 />}
                 <div className='border-left-2 me-2 d-block h-auto align-self-stretch'></div>
              </div>
              {!isAlertsFullscreen && <div className='close-alert-btn no-border-top'>
                <Buttons
                  label="close"
                  name=""
                  className='btn-bgcolor-6 whitetext p-0 btn btn-xs font-0 btn-border-radius-3 m-0 text-uppercase m-0 lh-normal'
                  icon="icon-rb-close font-8 p-1 d-block"
                  type="button"
                  ref={notificationPopup}
                  onClick={() => PopupWindow('notification-popup')}
                />
              </div>}
            </div>
            <div>
              <Tabs setActiveTab={(index: any) => { setActiveTab(index) }} tabClassName={activeTab ===0 ? 'active':'' } items={notification_items} anchorclass="darktext" className="custom-app-tabs sora-regular darktext" tabscontentarea="notification-content" tablistclassName="font-13" />
            </div>
            <div className='see-all-alerts py-3 justify-content-center w-100'>
                 <Buttons
                    label="See All Alerts"
                    name="See all Alerts"
                    className='p-0 btn btn-md text-color-11 font-13 sora-semibold m-0 lh-normal'
                    type="button"
                    onClick={showAlertsFull}
                  />
            </div>
          </>
        } popupActions={
          <>
          </>} />
      )}
    </div>
  )
}